<template>
    <img
        v-if="badge"
        :src="badge.icon"
        :alt="badge.id"
        :class="[$style.badge, isHide && $style.hidden, props.className]"
        loading="lazy"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { BadgeType } from '@/types'

import BadgeHotText from './images/hot-text.webp'
import BadgeNew from './images/new.webp'
import BadgeTopText from './images/top-text.webp'

interface BadgesProps {
    badges: BadgeType[] | undefined
    isHide?: boolean
    className?: string
}
const props = defineProps<BadgesProps>()

const badge = computed(() => {
    const badgeIcons = {
        hot: BadgeHotText,
        new: BadgeNew,
        top: BadgeTopText,
    }

    const priority = ['hot', 'top', 'new']
    const id = props.badges?.find((b) => priority.includes(b))

    return (
        id && {
            id,
            icon: badgeIcons[id as keyof typeof badgeIcons],
        }
    )
})
</script>

<style module>
.badge {
    position: absolute;
    top: -6px;
    left: -8px;

    height: 34px;
    width: auto;

    filter: opacity(100%);
    transition: all 0.4s ease-in-out;
    pointer-events: none;
}

.hidden {
    filter: opacity(0%);
}
</style>
